export default "__VITE_ASSET__47f462f8__"